"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactEasyCrop = _interopRequireDefault(require("react-easy-crop"));
var _ImageEditor = require("./ImageEditor.helpers");
var _ImageEditor2 = require("./ImageEditor.styles");
var _ImageEditor3 = require("./ImageEditor.labels");
var _hooks = require("../../hooks");
var _Input = require("../Input");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ImageEditor = /*#__PURE__*/_react.default.memo(function (props) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var getLabel = (0, _hooks.useLabels)({
    labels: _ImageEditor3.labels
  });
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var image = props.image,
    _props$minZoom = props.minZoom,
    minZoom = _props$minZoom === void 0 ? 1 : _props$minZoom,
    _props$maxZoom = props.maxZoom,
    maxZoom = _props$maxZoom === void 0 ? 3 : _props$maxZoom,
    _props$step = props.step,
    step = _props$step === void 0 ? 0.1 : _props$step,
    _props$cropShape = props.cropShape,
    cropShape = _props$cropShape === void 0 ? 'round' : _props$cropShape,
    onEditComplete = props.onEditComplete;
  var _useState = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    crop = _useState2[0],
    setCrop = _useState2[1];
  var _useState3 = (0, _react.useState)(1),
    _useState4 = _slicedToArray(_useState3, 2),
    zoom = _useState4[0],
    setZoom = _useState4[1];
  var styles = (0, _ImageEditor2.useStyles)();
  var isReady = (0, _react.useRef)(false);
  var zoomRef = (0, _react.useRef)(null);
  var intervalRef = (0, _react.useRef)();
  var handleZoomChange = (0, _react.useCallback)(function (value) {
    setZoom(Number(value));
  }, []);
  var handleCropperZoomChange = (0, _react.useCallback)(function (zoom) {
    setZoom(zoom);
  }, []);
  var handleCropChange = (0, _react.useCallback)(function (point) {
    return setCrop(point);
  }, []);
  var handleCropComplete = (0, _react.useCallback)(function (croppedArea, croppedAreaPixels) {
    if (image && isReady.current) {
      (0, _ImageEditor.getCroppedImg)(image, croppedAreaPixels).then(function (croppedImage) {
        if (onEditComplete) {
          onEditComplete(croppedImage);
        }
      });
    }
  }, [image, isReady, onEditComplete]);
  var zooming = function zooming(factor) {
    if (!zoomRef.current) {
      zoomRef.current = zoom;
    }
    zoomRef.current = Number((zoomRef.current + factor * step).toFixed(1));
    if (zoomRef.current < minZoom) {
      zoomRef.current = minZoom;
    } else if (zoomRef.current > maxZoom) {
      zoomRef.current = maxZoom;
    }
    handleCropperZoomChange(zoomRef.current);
  };
  var startZoomIn = function startZoomIn(event) {
    event.preventDefault();
    event.stopPropagation();
    zooming(1);
    intervalRef.current = setInterval(zooming, 100, 1);
  };
  var startZoomOut = function startZoomOut(event) {
    event.preventDefault();
    event.stopPropagation();
    zooming(-1);
    intervalRef.current = setInterval(zooming, 100, -1);
  };
  var stopZoom = function stopZoom(event) {
    event.preventDefault();
    event.stopPropagation();
    clearInterval(intervalRef.current);
    intervalRef.current = null;
    zoomRef.current = null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: image && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-ImageEditor'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ImageEditor__crop'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactEasyCrop.default, {
          image: image,
          crop: crop,
          zoom: zoom,
          aspect: 1,
          cropShape: cropShape,
          showGrid: false,
          onCropChange: handleCropChange,
          onCropComplete: handleCropComplete,
          onZoomChange: handleCropperZoomChange,
          onMediaLoaded: function onMediaLoaded(mediaSize) {
            setTimeout(function () {
              isReady.current = true;
            }, 0);
          },
          minZoom: minZoom,
          maxZoom: maxZoom
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-ImageEditor__slider'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
          type: "range",
          min: minZoom,
          max: maxZoom,
          step: step,
          value: zoom,
          onChange: handleZoomChange,
          ariaLabel: getLabel('zoom'),
          width: isMobileView ? "calc(100% - ".concat(pxToRem(72), ")") : 424
        }), isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-ImageEditor__zoom-in'],
            onMouseDown: startZoomIn,
            onTouchStart: startZoomIn,
            onMouseUp: stopZoom,
            onMouseLeave: stopZoom,
            onTouchEnd: stopZoom
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-ImageEditor__zoom-out'],
            onMouseDown: startZoomOut,
            onTouchStart: startZoomOut,
            onMouseUp: stopZoom,
            onMouseLeave: stopZoom,
            onTouchEnd: stopZoom
          })]
        })]
      })]
    })
  });
});
exports.ImageEditor = ImageEditor;